module.exports = __webpack_public_path__ + "img/step-logo.468f7839.png";